export default function QuizButton({ text, theme, handleClick }) {
  return (
    <button
      onClick={handleClick}
      onPointerDown={handleClick}
      className="w-full rounded-md px-6 py-6 shadow-2xl flex flex-col items-center justify-center transition hover:brightness-105 focus:outline-none"
      style={{
        backgroundColor: theme.buttonColor,
        color: theme.textColor,
        minHeight: '150px',
      }}
    >
      <span className="text-4xl md:text-4xl font-bold leading-tight uppercase">
        {text}
      </span>
    </button>
  );
}